import request from "@utils/request";

export function getDataDepositWithdrawal(query) {
    return request({
        url: "alert/data/deposit-withdrawal",
        method: "get",
        params: query
    });
}
